import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { DialogCloseDirective } from '@shared/directives/dialog-close.directive';
import { DataAttributeDirective } from '@shared/directives/data-attribute.directive';
import { LegalOrganizationManager } from '@shared/interfaces/profile/legal-organization-manager';
import { DEFAULT_OFFICE_PHONE_CONTACTS } from '@shared/consts/manager-contacts.constants';
import { parseWarehousePhones } from '@shared/utils/warehouse-phone';

export interface ManagerContactDialogData {
  manager: LegalOrganizationManager | null;
}

@Component({
  selector: 'b2b-portal-manager-contact-dialog',
  templateUrl: './manager-contact-dialog.component.html',
  styleUrl: './manager-contact-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, TranslocoDirective, TranslocoPipe, DialogCloseDirective, DataAttributeDirective],
})
export class ManagerContactDialogComponent {
  private readonly dialogConfig = inject<DynamicDialogConfig<ManagerContactDialogData>>(DynamicDialogConfig);

  private readonly manager = this.dialogConfig.data?.manager ?? null;

  protected readonly managerName = this.manager?.name ?? null;
  protected readonly managerPhone = this.manager?.phoneNumber ?? this.manager?.phones?.[0]?.number ?? null;
  // Warehouse contact of the synthetic manager, shown when no real manager contact is available.
  protected readonly warehouseAddress = this.manager?.warehouseAddress ?? null;
  // Warehouse phones split into individual numbers, each with its inline label when present.
  protected readonly warehousePhones = parseWarehousePhones(this.manager?.warehousePhone);
  // Дефолтные контакты (офис / отдел продаж / центральный), когда у менеджера нет телефона
  protected readonly defaultContacts = DEFAULT_OFFICE_PHONE_CONTACTS;
}
